import { PropsWithChildren, useMemo } from 'react'
import { createProgressBar } from './createProgressBar'
import { ProgressBarContext } from './ProgressBarContext'

export const ProgressBarProvider = ({
  children
}: PropsWithChildren<unknown>) => {
  const progressBar = createProgressBar()

  const progressBarContextValue = useMemo(() => progressBar, [progressBar])

  return (
    <ProgressBarContext.Provider value={progressBarContextValue}>
      {children}
    </ProgressBarContext.Provider>
  )
}
